<!-- =========================================================================================
  File Name: DataViewCameraSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4 style="word-break: normal;">Add New Camera</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <label class="vs-select--label w-full">Select Cameras</label>
         <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer ml-4 " v-if="groups && groups.length>0">
        <a class="flex items-center" style="font-size: .85rem;">
           Copy from group 
          <i class="material-icons">expand_more</i>
        </a>
        <vs-dropdown-menu style="z-index:9999999;">
          <vs-dropdown-item v-for="group in groups" :key=group.id @click="getGroupCamera(group)">
            {{group.name}}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
        <v-select  label="name"  multiple :closeOnSelect="true" v-model="dataCamera"  :options="cameras"/>

        <!-- <vs-select v-model="Camera" autocomplete label="Select Camera"  class="mt-5 w-full">
          <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in cameras" />
        </vs-select> -->

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import {ALL_CAMERAS, UPDATE_STUDENT_CAMERA, GET_CAMERA_BY_LOCATION, UPDATE_USER_ACTIVITY,GET_GROUPS_BY_LOCATION,GET_GROUP_CAMERAS } from '@/graphql'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      dataId: null,
      Camera:'',
      cameras : [],
      dataLocation:'',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      dataCamera:[],
      groups:[],
      dataGroup:[]
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, fname, lname, middle_name, nick_name, image, dob, status, location, program, cameras } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.getCameras(location.id)
        this.dataImg = image
        this.dataFirstName = fname
        this.dataMiddleName = middle_name
        this.dataLastName = lname
        this.dataNick = nick_name
        this.dataBirthday = dob
        this.dataCamera = cameras
        this.dataLocation = location.id
        this.dataProgram = program.id
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataCamera.length  > 0
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    StatusSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Cameras updated successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const getcamerasids = []
          for (let j = 0; j < this.dataCamera.length; j++) {
            const getcameraid = this.dataCamera[j].id
            getcamerasids.push(getcameraid)
          }
          // this.dataCamera = getcamerasids
          // this.dataCamera.push(this.Camera)
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_STUDENT_CAMERA,
                variables: {
                  id:this.dataId,
                  cameras: getcamerasids
                }
              })
              .then(response => {
                if (response) {
                  this.StatusSuccess()
                  this.updateUserActivity()

                }
              }).catch(error => {
                console.log(error)
              })
            // this.$store.dispatch('dataList/updateStudent', obj).catch(err => { console.error(err) })
          }
          this.$emit('closeSidebar')
          this.Camera = null
          this.dataCamera = [],
          this.initValues()
        }
      })
    },
    updateUserActivity () {

      this.$apollo
        .mutate({
          mutation: UPDATE_USER_ACTIVITY,
          variables: {
            object_id: this.dataId,
            object_type:'App\\Models\\Student',
            activity:'updated'
          }
        })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    getGroupCamera(group){
      if(group.id){
        this.$apollo
        .mutate({
          mutation: GET_GROUP_CAMERAS,
          variables: {
            group_id:group.id
          }
        })
        .then(response => {
          if (response) {
            var cameras= response.data.getGroupCameras;
            for (let index = 0; index < cameras.length; index++) {
              this.dataCamera.push(cameras[index])
            }
             this.dataCamera=this.dataCamera.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    getCameras (id) {
      this.$apollo
        .mutate({
          mutation: GET_CAMERA_BY_LOCATION,
          variables: {
            location_id:id
          }
        })
        .then(response => {
          if (response) {
            this.cameras = response.data.location_cameras
          }
        }).catch(error => {
          console.log(error)
        })

        this.$apollo
        .mutate({
          mutation: GET_GROUPS_BY_LOCATION,
          variables: {
            location_id:id
          }
        })
        .then(response => {
          if (response) {
            this.dataGroup = []
            this.groups = response.data.location_groups
          }
        }).catch(error => {
          console.log(error)
        })
    }
    
  },
  created () {


  }

}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
